import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

const PermissionGuard = ({ 
  permission,
  children, 
  unauthorizedView = <Navigate to="/auth/404" /> 
}) => {
  const { permissions } = useSelector((state) => state.permissionsReducer);

  if (permission && !permissions?.Capabilities?.includes(permission)) {
    return unauthorizedView;
  }

  return children;
};

export default PermissionGuard;